import { render, staticRenderFns } from "./app_02_anti_static.vue?vue&type=template&id=f71533c0&lang=pug&"
import script from "./app_02_anti_static.vue?vue&type=script&lang=js&"
export * from "./app_02_anti_static.vue?vue&type=script&lang=js&"
import style0 from "./app_02_anti_static.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports